import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import Step from "./Step";

const step1 = [
  { id: "Step 1", name: "Select SOP type", status: "current" },
  // { id: "Step 2", name: "Basic Details", status: "upcoming" },
  { id: "Step 2", name: "Customize SOP", status: "upcoming" },
];

// const step2 = [
//   { id: "Step 1", name: "Select SOP type", status: "complete" },
//   // { id: "Step 2", name: "Basic Details", status: "current" },
//   { id: "Step 3", name: "Customize SOP", status: "upcoming" },
// ];
const step3 = [
  { id: "Step 1", name: "Select SOP type", status: "complete" },
  // { id: "Step 2", name: "Basic Details", status: "complete" },
  { id: "Step 2", name: "Customize SOP", status: "current" },
];

const steps = [step1, step3];

const StepIndicator = ({ step }: { step: number }) => {
  // const router = useRouter();
  // const [routes, setRoutes] = useState<string[]>([]);
  // const [currentStep, setCurrentStep] = useState<any>(steps[step - 1]);
  // const [loading, setLoading] = useState<boolean>(true);
  // useEffect(() => {
  //   // console.log(router.query);
  //   setLoading(true);
  //   const query = router.query;
  //   const sopId = query.sopId;
  //   console.log(sopId);
  //   setRoutes([
  //     `/sop/new/${sopId}/step-1`,
  //     `/sop/new/${sopId}/step-2`,
  //     `/sop/new/${sopId}/step-3`,
  //   ]);

  //   const temp = [...currentStep];
  //   temp.map((step, index) => {
  //     step.href = routes[index];
  //   });
  //   setCurrentStep(temp);
  //   setLoading(false);
  // }, []);

  return (
    <nav aria-label="Progress">
      <ol role="list" className="flex space-x-4 md:space-x-8">
        {steps[step - 1]?.map((step: any, index: number) => (
          <Step key={index} step={step} />
        ))}
      </ol>
    </nav>
  );
};

export default StepIndicator;
